import { useEffect, useState } from "react";
import useNear from "./nearHook";

const useApi = () => {
  const near = useNear();

  const getApi = (endpoint) => {
    const sbtEndpoint = endpoint.trim().replace(/\/$/, "");

    const getSbt = async (tokenId, authContract = null) => {
      // TODO: use sign; implement endpoints
      const signedUserHeader = await near.account.signForHeader(tokenId);

      try {
        const r = await fetch(`${sbtEndpoint}/sbt/${tokenId}`, {
          headers: {
            "x-signed-user": signedUserHeader,
            ...(authContract ? {"x-authorization-contract": authContract}: {})
          },
        });

        return await r.json();
      } catch (e) {
        console.error(e)
        return {};
      }
    };

    const createTokens = async (owner_id, tokens) => {
      const r = await fetch(`${sbtEndpoint}/sbt`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          owner_id,
          tokens
        })
      });

      return await r.json()
    }

    const getSchemas = async () => {
      const r = await fetch(`${sbtEndpoint}/schema`)
      return await r.json()
    }

    return {
      getSbt,
      createTokens,
      getSchemas
    };
  };

  return { getApi };
};

export default useApi;
